// extracted by mini-css-extract-plugin
export default {"personboost_container":"E1","personboost_content":"F1","personboost_title":"G1","personboost_text":"H1","toleft":"I1","personboost_tiles_container":"J1","personalized_tiles_container":"K1"};
    if(module.hot) {
      // 1714654899594
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  